import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke021aRequest, Sgke021aResponse, Sgke021aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
/**
 *SGKE021A_未精算整理詳細承認依頼取消API処理
 * @export
 * @class UsedSgke021aService
 */
@Injectable({
  providedIn: 'root'
})

export class UsedSgke021aService {
  /**
   * コンストラクタ
   * @param {Sgke021aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcConfig
   * @memberof UsedSgke021aService
   */
  constructor(public service: Sgke021aService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibcConfig: FeaturesLibConfig) { }
  /**
   * SGKE021A_未精算整理詳細承認依頼取消API呼び出し
   * @param request 
   * @returns 
   */
  public doSgke021a(request: Sgke021aRequest): Observable<Sgke021aResponse> {
    return this.service.ke10WSGKE021APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE021A');
          return throwError(err.message);
        })
      );
  }
}


